//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { useContext } from "react";

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
import Context from "context/context";

function UserDetailsAPI() {
    const { state, dispatch } = useContext(Context);
    const { handleResponse, handleError } = HandleApiResponse();

    async function getUserDetailsAPI(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let query;
            query = JSON.stringify(values)
            let res = await fetch(
                `${config.host}/cdr-panel/api/userdetails?query=${query}`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }

    async function searchAPI(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let query;
            query = JSON.stringify(values)
            let res = await fetch(
                `${config.host}/cdr-panel/api/userdetails/search?query=${query}`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }

    async function filterAPI(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let query;
            query = JSON.stringify(values)
            let res = await fetch(
                `${config.host}/cdr-panel/api/userdetails/filter?query=${query}`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }

    async function exportAPI(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let query;
            query = JSON.stringify(values)
            let res = await fetch(
                `${config.host}/cdr-panel/api/userdetails/export?query=${query}`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }

    async function getOnewebAllowedUsersAPI(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let query;
            query = JSON.stringify(values)
            let res = await fetch(
                `${config.host}/cdr-panel/api/userdetails/get-oneweb-allowed-users?query=${query}`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }

    async function searchOnewebAllowedUsersAPI(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let query;
            query = JSON.stringify(values)
            let res = await fetch(
                `${config.host}/cdr-panel/api/userdetails/search-oneweb-allowed-users?query=${query}`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }

    async function createOnewebAllowedUsersAPI(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
                body: JSON.stringify(values)
            };

            let res = await fetch(
                `${config.host}/cdr-panel/api/userdetails/create-oneweb-allowed-users`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }

    async function deleteOnewebAllowedUsersAPI(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
                body: JSON.stringify(values)
            };

            let res = await fetch(
                `${config.host}/cdr-panel/api/userdetails/delete-oneweb-allowed-users`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }

    async function handleCanadaOnewebRestrictedShipto(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
                body: JSON.stringify(values)
            };

            let res = await fetch(
                `${config.host}/cdr-panel/api/userdetails/canada-oneweb-restrcited-shipto`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }

    return {
        getUserDetailsAPI,
        searchAPI,
        filterAPI,
        exportAPI,
        getOnewebAllowedUsersAPI,
        searchOnewebAllowedUsersAPI,
        createOnewebAllowedUsersAPI,
        deleteOnewebAllowedUsersAPI,
        handleCanadaOnewebRestrictedShipto
    }

}

export default UserDetailsAPI